import {Injectable} from '@angular/core';
import {Router} from "@angular/router";
import {Subject} from "rxjs/Subject";

@Injectable()
export class SharedService {

  private parameters: any = {};
  private data: any = {};
  public selectedTab: string
  public rfqSubject = new Subject();
  public rfq: string
  public leadStatusSubject = new Subject();
  public displayBuyerSubject = new Subject();
  constructor() {
    const data = localStorage.getItem('parameters');
    if (data) {
      this.parameters = JSON.parse(data);
      this.parameters['selectedPricingPlan'] = null;
    }
  }

  getParameter(key, refresh: boolean = false) {
    if (refresh) {
      const data = localStorage.getItem('parameters');
      if (data) {
        this.parameters = JSON.parse(data);
      }
    }
    return this.parameters[key];
  }

  setParameter(key, value) {
    this.parameters[key] = value;
    localStorage.setItem('parameters', JSON.stringify(this.parameters));
  }

  decodeBase64(value: string): string {
    if (value) {
      try {
        const decodedValue = atob(value);
        return decodedValue;
      } catch (exception) {
        return value;
      }
    }
    return '';
  }

  encodeBase64(value: string): string {
    if (value) {
      const encodedValue = btoa(value);
      return encodedValue;
    }
    return '';
  }

  navigateToProfile(profile, router: Router) {
    const appName = encodeURIComponent(profile.name.split(' ').join('-'));
    const id = encodeURIComponent(this.encodeBase64(profile.id));
    router.navigateByUrl(`/profile/${id}/${appName}`);
  }

  /**
   *  in memory data, not stored in local storage
   * @param key
   * @returns {any}
   */
  getData(key) {
    return this.data[key];
  }

  setData(key, value) {
    this.data[key] = value;
  }

  getSelectedTab() {
    return this.selectedTab;
  }
}



// WEBPACK FOOTER //
// ./src/app/services/shared.service.ts